<template>
  <!-- Widget -->
  <div>
    <LmListV2
      :key="key"
      :isGraphql="true"
      :gqlField="listProps.gqlField"
      :gqlVariables="listProps.gqlVariables"
      :gqlQuery="listProps.gqlQuery"
      :searchOnFieldsSelected="listProps.searchOnFieldsSelected"
      :searchOnFieldsToSelected="listProps.searchOnFieldsToSelected"
      :allAvailableFields="allAvailableFields"
      :mode="listProps.mode"
      :listBuilderTitleList="listProps.listBuilderTitleList"
      :listBuilderButtons="listProps.listBuilderButtons"
      :isOnWidgetMode="true"
      :listBuilderId="listProps._id"
    />
  </div>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'

// Base component
import LmListV2 from '@/components/LmListV2'

export default {
  components: {
    LmListV2
  },
  props: {
    widget: {
      type: Object
    },
    customization: {
      type: Object
    }
  },
  data () {
    return {
      listProps: {},
      key: 0
    }
  },
  computed: {
    allAvailableFields () {
      return this.listProps?.fields?.map(f => {
        return {
          key: f.key,
          label: f.label,
          sortable: false
        }
      }) || null
    }
  },
  methods: {
    async loadListData (dataOrigin) {
      if (dataOrigin && typeof dataOrigin === 'object' && !Array.isArray(dataOrigin)) {
        try {
          const list = await commonsApi.axiosGetWrapper(`/listbuilder/${dataOrigin.id}`)
          this.listProps = list.data
          this.key++
        } catch (error) {
          console.log(error)
        }
      }
    }
  },
  watch: {
    'widget.dataOrigin': {
      async handler (val) {
        await this.loadListData(val)
      },
      deep: true,
      inmediate: true
    }
  },
  async created () {
    await this.loadListData(this.widget?.dataOrigin)
  }
}
</script>

<style>

</style>
